import type { PageBlock } from '../../lib/types';

export function mediaUrl(mediaId: string) {
  return `/api/public/media/${encodeURIComponent(mediaId)}/content`;
}

export function BlockRenderer({ blocks }: { blocks: PageBlock[] }) {
  return <>{blocks.map((block) => {
    if (block.type === 'heading') return block.level === 3 ? <h3 key={block.id}>{block.text}</h3> : <h2 key={block.id}>{block.text}</h2>;
    if (block.type === 'paragraph') return <p key={block.id}>{block.text}</p>;
    if (block.type === 'list') { const items = block.items.map((item, index) => <li key={index}>{item}</li>); return block.ordered ? <ol key={block.id}>{items}</ol> : <ul key={block.id}>{items}</ul>; }
    if (block.type === 'quote') return <figure key={block.id}><blockquote>{block.text}</blockquote>{block.attribution && <figcaption>{block.attribution}</figcaption>}</figure>;
    return <figure key={block.id}><img src={mediaUrl(block.mediaId)} alt={block.altText} loading="lazy" />{block.caption && <figcaption>{block.caption}</figcaption>}</figure>;
  })}</>;
}
